import React, { useState } from "react";
import {
  Navbar,
  Nav,
  Container,
  Button,
  Offcanvas,
  Row,
  Col,
} from "react-bootstrap";
import { siteLogo as logo } from "../../const";
import { useNavigate } from "react-router-dom";
import {
  about,
  chatUsers,
  chatWithAgent,
  contact,
  privacyPolicy,
  quickReply,
  broadcast,
  termAndCondition,
  users,
  userprofile,
} from "../../const";
import { useSelector } from "react-redux";
import LastLocation from "./LastLocation";
import socket from "../../socketInstance";
import NotificationBell from "../../Components/NotificationBell";

const NavbarWithDrawer = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const userSlug = localStorage.getItem("slug");
  const canOpenProfile = ["customer", "team_leader", "branch_leader"].includes(
    userSlug
  );

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { getMyProfileData } = useSelector((state) => state.commonReducer);

  return (
    <>
      {/* Top Navbar */}
      <Navbar className="bg-themesecond" variant="dark" expand="lg" fixed="top">
        {localStorage.getItem("slug") === "admin" && (
          <Button variant="success" className="mx-2">
            <LastLocation />
          </Button>
        )}
        <Container>
          <span onClick={handleShow} className="me-2 f-18">
            ☰
          </span>
          <Navbar.Brand className="text-dark">
            <b>{process.env.REACT_APP_SITE_NAME}</b>
          </Navbar.Brand>
          {localStorage.getItem("x-auth-token") && <NotificationBell />}
          <span
            onClick={() => canOpenProfile && navigate(userprofile)}
            className="me-2 f-18"
          >
            {canOpenProfile && (
              <i className="bi bi-person-circle"></i>
            )}
          </span>
        </Container>
      </Navbar>
      <div className="navbar-with-drawer-offset" />

      {/* Sidebar Drawer */}
      <Offcanvas show={show} onHide={handleClose} backdrop="true">
        <Offcanvas.Header closeButton className="bg-themesecond">
          <Offcanvas.Title>
            <Row className="w-200">
              <Col md={3} sm={3} xs={3} className="p-0">
                <img
                  className="profile-img"
                  src={getMyProfileData?.image ? getMyProfileData?.image : logo}
                />
              </Col>
              <Col md={9} sm={9} xs={9}>
                <p className="mb-0 m-f-13">
                  <b>
                    {getMyProfileData?.firstName} {getMyProfileData?.lastName}
                  </b>
                </p>
                <p className="mb-0 m-f-13">{getMyProfileData?.phone}</p>
              </Col>
            </Row>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {canOpenProfile && (
            <Row
              className="f-18 mb-1 cursor-pointer"
              onClick={() => {
                navigate(userprofile);
                handleClose();
              }}
            >
              <Col md={2} sm={2} xs={2}>
                <i className="bi bi-person-circle"></i>
              </Col>
              <Col md={10} sm={10} xs={10}>
                <p className="mb-2">My Profile</p>
              </Col>
            </Row>
          )}
          {userSlug === "customer" && (
            <>
              <Row
                className="f-18 mb-1 cursor-pointer"
                onClick={() => {
                  navigate(chatUsers);
                  handleClose();
                }}
              >
                <Col md={2} sm={2} xs={2}>
                  <i className="bi bi-people-fill"></i>
                </Col>
                <Col md={10} sm={10} xs={10}>
                  <p className="mb-2">Chat</p>
                </Col>
              </Row>
            </>
          )}
          {userSlug === "team_leader" && (
            <>
              <Row
                className="f-18 mb-1 cursor-pointer"
                onClick={() => {
                  navigate(`${chatUsers}?createGroup=true`);
                  handleClose();
                }}
              >
                <Col md={2} sm={2} xs={2}>
                  <i className="bi bi-people-fill"></i>
                </Col>
                <Col md={10} sm={10} xs={10}>
                  <p className="mb-2">Create Group</p>
                </Col>
              </Row>
              <Row
                className="f-18 mb-1 cursor-pointer"
                onClick={() => {
                  navigate(quickReply);
                  handleClose();
                }}
              >
                <Col md={2} sm={2} xs={2}>
                  <i className="bi bi-people-fill"></i>
                </Col>
                <Col md={10} sm={10} xs={10}>
                  <p className="mb-2">Quick Reply</p>
                </Col>
              </Row>
              <Row
                className="f-18 mb-1 cursor-pointer"
                onClick={() => {
                  navigate(broadcast);
                  handleClose();
                }}
              >
                <Col md={2} sm={2} xs={2}>
                  <i className="bi bi-megaphone-fill"></i>
                </Col>
                <Col md={10} sm={10} xs={10}>
                  <p className="mb-2">Broadcast</p>
                </Col>
              </Row>
              <Row
                className="f-18 mb-1 cursor-pointer"
                onClick={() => {
                  navigate(chatUsers);
                  handleClose();
                }}
              >
                <Col md={2} sm={2} xs={2}>
                  <i className="bi bi-people-fill"></i>
                </Col>
                <Col md={10} sm={10} xs={10}>
                  <p className="mb-2">Chat</p>
                </Col>
              </Row>
              <Row
                className="f-18 mb-1 cursor-pointer"
                onClick={() => {
                  navigate(`${chatWithAgent}?agent=true`);
                  handleClose();
                }}
              >
                <Col md={2} sm={2} xs={2}>
                  <i className="bi bi-people-fill"></i>
                </Col>
                <Col md={10} sm={10} xs={10}>
                  <p className="mb-2">Chat with Agent</p>
                </Col>
              </Row>
            </>
          )}
          {userSlug === "branch_leader" && (
            <>
              <Row
                className="f-18 mb-1 cursor-pointer"
                onClick={() => {
                  navigate(chatUsers);
                  handleClose();
                }}
              >
                <Col md={2} sm={2} xs={2}>
                  <i className="bi bi-chat-dots"></i>
                </Col>
                <Col md={10} sm={10} xs={10}>
                  <p className="mb-2">Chat</p>
                </Col>
              </Row>
              <Row
                className="f-18 mb-1 cursor-pointer"
                onClick={() => {
                  navigate(`${chatUsers}?createGroup=true`);
                  handleClose();
                }}
              >
                <Col md={2} sm={2} xs={2}>
                  <i className="bi bi-people-fill"></i>
                </Col>
                <Col md={10} sm={10} xs={10}>
                  <p className="mb-2">Create Group</p>
                </Col>
              </Row>
              <Row
                className="f-18 mb-1 cursor-pointer"
                onClick={() => {
                  navigate(users);
                  handleClose();
                }}
              >
                <Col md={2} sm={2} xs={2}>
                  <i className="bi bi-people-fill"></i>
                </Col>
                <Col md={10} sm={10} xs={10}>
                  <p className="mb-2">Users</p>
                </Col>
              </Row>
              <Row
                className="f-18 mb-1 cursor-pointer"
                onClick={() => {
                  navigate("/admin-group-chats");
                  handleClose();
                }}
              >
                <Col md={2} sm={2} xs={2}>
                  <i className="bi bi-collection-fill"></i>
                </Col>
                <Col md={10} sm={10} xs={10}>
                  <p className="mb-2">Groups</p>
                </Col>
              </Row>
            </>
          )}
          <Row
            className="f-18 mb-1 cursor-pointer"
            onClick={() => {
              navigate(about);
            }}
          >
            <Col md={2} sm={2} xs={2}>
              <i className="bi bi-info-circle"></i>
            </Col>
            <Col md={10} sm={10} xs={10}>
              <p className="mb-2">About Us</p>
            </Col>
          </Row>
          <Row
            className="f-18 mb-1 cursor-pointer"
            onClick={() => {
              navigate(privacyPolicy);
            }}
          >
            <Col md={2} sm={2} xs={2}>
              <i className="bi bi-lock-fill"></i>
            </Col>
            <Col md={10} sm={10} xs={10}>
              <p className="mb-2">Privacy Policy</p>
            </Col>
          </Row>
          <Row
            className="f-18 mb-1 cursor-pointer"
            onClick={() => {
              navigate(termAndCondition);
            }}
          >
            <Col md={2} sm={2} xs={2}>
              <i className="bi bi-lock-fill"></i>
            </Col>
            <Col md={10} sm={10} xs={10}>
              <p className="mb-2">Term & Conditions</p>
            </Col>
          </Row>
          <Row
            className="f-18 mb-1 cursor-pointer"
            onClick={() => {
              navigate(contact);
            }}
          >
            <Col md={2} sm={2} xs={2}>
              <i className="bi bi-question-circle"></i>
            </Col>
            <Col md={10} sm={10} xs={10}>
              <p className="mb-2">Help</p>
            </Col>
          </Row>
          {localStorage.getItem("x-auth-token") && (
            <Row
              className="f-18 mb-1 cursor-pointer"
              onClick={() => {
                if (socket.connected) {
                  socket.disconnect();
                  console.log("🔌 Socket disconnected");
                }
                localStorage.clear();
                navigate("/");
                window.location.reload();
              }}
            >
              <Col md={2} sm={2} xs={2}>
                <i className="bi bi-box-arrow-right text-danger"></i>
              </Col>
              <Col md={10} sm={10} xs={10}>
                <p className="mb-2 text-danger">LogOut</p>
              </Col>
            </Row>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default NavbarWithDrawer;
